import script from "./uneighteen_page.vue?vue&type=script&setup=true&lang=js"
export * from "./uneighteen_page.vue?vue&type=script&setup=true&lang=js"

import "./uneighteen_page.vue?vue&type=style&index=0&id=6e92716a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e92716a"]])

export default __exports__